import { Button, Input, List, message, Modal } from "antd";
import React, { ReactNode, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { connect } from "dvajs";
import { useTranslation } from "react-i18next";
import { EbookState } from "@/models/ebook";
import "./index.less";
import externalContactsSuccess from "@/assets/img/externalContacts/success.png";
import externalContactsFail from "@/assets/img/externalContacts/fail.png";
import externalContactsInvalid from "@/assets/img/externalContacts/invalid.png";
import { ExternalContactsStatus } from "@/types/chat/enum";
import * as util from "@/components/Joyspace/util";
import dayjs from "dayjs";
import { changeEgovUrl } from "@/utils/tools";
import { contactsListInfo } from ".";
import { externalTitleType } from "../ManageExternal/ExternalApplyList";

function ExternalItem({
  data: item,
  handleClouseRefuse,
  handleAdd,
  titleNode,
  origin
}: {
  data: contactsListInfo;
  handleClouseRefuse: Function;
  handleAdd: Function;
  titleNode: any;
  origin: number; // 1 正式用户申请/外部联系人加入 2 管理端消息通知申请账号延期申请列表 3 外部联系人端消息通知申请列表
}) {
  const [t] = useTranslation("chat");
  const [refusalCause, setRefusalCause] = useState("");
  const contentNode = useMemo(() => {
    return (
      <div className={`external-contacts-content ${item.desc ? "external-apply-content" : ""}`}>
        <div className="content-title">{titleNode}</div>
        {item.desc && (
          <p
            dangerouslySetInnerHTML={{
              __html: item.desc?.replace(/\n/g, "<br/>")
            }}
          />
        )}
        {item.operateName && externalTitleType(item.type, item.apprStatus)?.isShowOperator && (
          <div>
            <span className="label">操作人：</span>
            <span className="container">{item.operateName}</span>
          </div>
        )}
        {item.employeeTypeName && (
          <div>
            <span className="label">{t("application_type")}：</span>
            <span className="container">{item.employeeTypeName}</span>
          </div>
        )}
        {item.applyReason && (
          <div>
            <span className="label">申请原因：</span>
            <span
              className="container"
              dangerouslySetInnerHTML={{
                __html: item.applyReason?.replace(/\n/g, "<br/>")
              }}
            />
          </div>
        )}
        {item.delayStartDate && item.delayEndDate && (
          <div>
            <span className="label">延期时段：</span>
            <span className="container">
              {`${util.chineseTime.format(item.delayStartDate, true)} -
                            ${util.chineseTime.format(item.delayEndDate, true)}`}
            </span>
          </div>
        )}
        {origin !== 1 && item.deptName && (
          <div>
            <span className="label">单位名称：</span>
            <span className="container">{item.deptName}</span>
          </div>
        )}
        {origin !== 1 && item.titleName && (
          <div>
            <span className="label">职位名称：</span>
            <span className="container">{item.titleName}</span>
          </div>
        )}
        {origin === 1 && item.employeeType === 2 && (
          <>
            <div>
              <span className="label">{t("unit")}：</span>
              <span className="container">{item.deptName}</span>
            </div>
            <div>
              <span className="label">{t("post")}：</span>
              <span className="container">{item.titleName}</span>
            </div>
          </>
        )}
        {origin === 1 && item.employeeType === 1 && (
          <>
            <div>
              <span className="label">{t("unit")}：</span>
              <span className="container">{item.unitName}</span>
            </div>
            <div>
              <span className="label">{t("dept")}：</span>
              <span className="container">{item.deptName}</span>
            </div>
          </>
        )}
        {item.apprOption && (
          <div>
            <span className="label">驳回原因：</span>
            <span
              className="container"
              dangerouslySetInnerHTML={{
                __html: item.apprOption?.replace(/\n/g, "<br/>")
              }}
            />
          </div>
        )}
        {item.gmtCreate && (
          <div>
            <span className="label">{t("time")}：</span>
            <span className="container">{util.chineseTime.format(item.gmtCreate)}</span>
          </div>
        )}
        {item.applyDate && (
          <div>
            <span className="label">申请时间：</span>
            <span className="container">{util.chineseTime.format(item.applyDate)}</span>
          </div>
        )}
      </div>
    );
  }, [item, t, titleNode, origin]);

  const textareaNode = useMemo(() => {
    return (
      <div className="refusal-cause">
        <Input.TextArea
          placeholder={origin === 3 ? "请输入延期申请原因" : "请输入驳回原因"}
          rows={4}
          defaultValue={refusalCause}
          onChange={(e) => {
            setRefusalCause(e.target.value.trim());
          }}
          maxLength={100}
        />
        <p className="refusal-cause-length">
          <span>{refusalCause.length || 0}</span>
          /100
        </p>
        <p className="refusal-cause-btns">
          <Button
            className="refusal-cause-btns-cancel"
            onClick={() => {
              setRefusalCause("");
              handleClouseRefuse(item, false);
            }}
          >
            {t("cancelText")}
          </Button>
          <Button
            disabled={!refusalCause}
            className="refusal-cause-btns-ok"
            type="primary"
            loading={item.loading}
            onClick={() => {
              handleAdd(item, 2, refusalCause);
            }}
          >
            {t("confirm")}
          </Button>
        </p>
      </div>
    );
  }, [handleAdd, handleClouseRefuse, item, origin, refusalCause, t]);

  return (
    <div className="external-contacts-list-item ">
      {/* 蒙层 */}
      {(item.apprStatus === ExternalContactsStatus.INVALID ||
        item.apprStatus === ExternalContactsStatus.ALREADY_APPR ||
        item.apprStatus === ExternalContactsStatus.ALREADY_EXSIT) && (
        <div className="external-contacts-list-item-Mantle"> </div>
      )}
      <div className="external-contacts-item-detail">
        {contentNode}
        {origin !== 3 && (
          <div className="external-contacts-status">
            {item.apprStatus === ExternalContactsStatus.SUCCESS && (
              <img src={changeEgovUrl(externalContactsSuccess)} alt="" />
            )}
            {item.apprStatus === ExternalContactsStatus.FAIL && (
              <img src={changeEgovUrl(externalContactsFail)} alt="" />
            )}
            {item.apprStatus === ExternalContactsStatus.INVALID && (
              <img src={changeEgovUrl(externalContactsInvalid)} alt="" />
            )}
          </div>
        )}
      </div>
      {item.refuse && textareaNode}
      <div className="external-contacts-item-fun">
        {item.apprStatus === ExternalContactsStatus.WAIT && !item.refuse && (
          <>
            <Button
              className="refuse"
              onClick={() => {
                handleClouseRefuse(item, true);
              }}
            >
              {t("not approved")}
            </Button>
            <Button
              className="agreed"
              type="primary"
              loading={item.loading}
              onClick={() => {
                handleAdd(item, 1);
              }}
            >
              {t("approved")}
            </Button>
          </>
        )}
        {item.type === 2 && !item.refuse && (
          <Button
            type="primary"
            onClick={() => {
              setRefusalCause("");
              handleClouseRefuse(item, true);
            }}
          >
            申请延期
          </Button>
        )}
      </div>
    </div>
  );
}

function mapStateToProps({ ebook }: { ebook: EbookState }) {
  return {};
}

function mapDispatchToProps(dispatch: any) {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(ExternalItem);
